(() => {
  const offer = document.querySelector("[data-cb-site-offer]");
  const panel = document.querySelector("[data-cb-support-panel]");
  const backdrop = document.querySelector("[data-cb-support-backdrop]");
  const closeButton = document.querySelector("[data-cb-support-close]");
  let lastSupportTrigger = null;

  if (offer) {
    document.body.classList.add("cb-site-tools-active");
    const syncOfferOffset = () => {
      document.documentElement.style.setProperty(
        "--cb-site-offer-height",
        `${Math.ceil(offer.getBoundingClientRect().height)}px`
      );
    };
    syncOfferOffset();
    if ("ResizeObserver" in window) {
      new ResizeObserver(syncOfferOffset).observe(offer);
    } else {
      window.addEventListener("resize", syncOfferOffset, { passive: true });
    }
  }

  if (document.querySelector(".cn-sticky, .cb-sticky, [data-cb-sticky-cart]")) {
    document.body.classList.add("cbx-has-sticky-cart");
  }

  const track = (name, detail = {}) => {
    const payload = {
      event: name,
      page_path: window.location.pathname,
      ...detail
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    window.dispatchEvent(new CustomEvent(`conebarn:${name}`, { detail: payload }));

    if (window.Shopify?.analytics?.publish) {
      try {
        window.Shopify.analytics.publish(name, payload);
      } catch (error) {
        // Other analytics sinks still receive the event.
      }
    }
  };

  const setCouponState = (applied) => {
    if (!offer) return;
    const copy = offer.querySelector("[data-cb-offer-copy]");
    const button = offer.querySelector("[data-cb-apply-coupon]");
    offer.classList.toggle("is-applied", applied);

    if (copy) {
      copy.textContent = applied
        ? "WELCOME1 selected. Best eligible offer shows at checkout."
        : "Welcome offer: $1 off. Code WELCOME1.";
    }

    if (button) {
      button.textContent = applied ? "Reapply" : "Save coupon";
      button.disabled = false;
    }
  };

  const applyCoupon = () => {
    if (!offer) return;
    const code = offer.dataset.couponCode;
    if (!code) return;

    try {
      window.sessionStorage.setItem("cb_coupon_welcome1_session_v1", "true");
    } catch (error) {
      // The Shopify discount route remains functional without session storage.
    }

    track("coupon_apply", {
      coupon_code: code,
      coupon_offer: "one_dollar_order_nonstacking"
    });
    const returnPath = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    window.location.assign(`/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(returnPath)}`);
  };

  const openSupport = (trigger) => {
    if (!panel || !backdrop) return;
    lastSupportTrigger = trigger || document.activeElement;
    panel.hidden = false;
    backdrop.hidden = false;
    requestAnimationFrame(() => {
      panel.classList.add("is-open");
      backdrop.classList.add("is-open");
      document.body.classList.add("cb-support-lock");
      closeButton?.focus();
    });
    track("support_open");
  };

  const closeSupport = () => {
    if (!panel || !backdrop) return;
    panel.classList.remove("is-open");
    backdrop.classList.remove("is-open");
    document.body.classList.remove("cb-support-lock");
    window.setTimeout(() => {
      panel.hidden = true;
      backdrop.hidden = true;
    }, 220);
    lastSupportTrigger?.focus?.();
  };

  document.addEventListener("click", (event) => {
    const clickedElement = event.target instanceof Element ? event.target : null;
    const actionElement = clickedElement?.closest(
      "a,button,input,select,summary,[role='button'],[data-cb-track-label]"
    );
    const viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    const viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    const destination = actionElement?.tagName === "A"
      ? actionElement.getAttribute("href")
      : null;

    track("site_click", {
      click_x_pct: viewportWidth ? Math.round((event.clientX / viewportWidth) * 1000) / 10 : null,
      click_y_pct: viewportHeight ? Math.round((event.clientY / viewportHeight) * 1000) / 10 : null,
      element_tag: (actionElement || clickedElement)?.tagName?.toLowerCase() || "unknown",
      element_id: (actionElement || clickedElement)?.id || null,
      element_role: actionElement?.getAttribute("role") || null,
      element_label:
        actionElement?.dataset.cbTrackLabel ||
        actionElement?.getAttribute("aria-label") ||
        null,
      destination: destination?.startsWith("/") ? destination.split("?")[0] : null,
      is_interactive: Boolean(actionElement),
      viewport_width: viewportWidth,
      viewport_height: viewportHeight
    });

    const couponTrigger = event.target.closest("[data-cb-apply-coupon]");
    if (couponTrigger) {
      event.preventDefault();
      applyCoupon();
      return;
    }

    const supportTrigger = event.target.closest("[data-cb-support-trigger]");
    if (supportTrigger) {
      event.preventDefault();
      openSupport(supportTrigger);
      return;
    }

    const supportLink = event.target.closest("[data-cb-support-link]");
    if (supportLink) {
      track("support_contact_click", { destination: supportLink.dataset.cbSupportLink });
    }
  });

  closeButton?.addEventListener("click", closeSupport);
  backdrop?.addEventListener("click", closeSupport);
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && panel?.classList.contains("is-open")) {
      closeSupport();
    }
  });

  let couponApplied = false;
  try {
    couponApplied = window.sessionStorage.getItem("cb_coupon_welcome1_session_v1") === "true";
  } catch (error) {
    couponApplied = false;
  }
  setCouponState(couponApplied);

  window.ConeBarnSiteTools = {
    applyCoupon,
    openSupport,
    track
  };
})();
